/**
 * Created by DSadler on 20/04/2017.
 */

import {editor} from "../Editor/state/reducers";
import {combineReducers} from "redux";
import {emails} from "./emails/reducers";
import {images} from "./images/reducers";
import {templates} from "./templates/reducers";

const reduxStore = combineReducers({
  editor,
  emails,
  images,
  templates,
});

export { reduxStore };


// WEBPACK FOOTER //
// ./src/App/state/index.js